var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { minHeight: _vm.hideCompare ? "80px" : "110px" } },
    [
      _c(
        "div",
        { staticClass: "d-flex gap-2 items-start pa-4" },
        [
          !_vm.noIcon
            ? _c(
                "v-icon",
                { attrs: { color: "primary lighten-4", size: "32", left: "" } },
                [_vm._v(_vm._s(_vm.icon))]
              )
            : _vm._e(),
          _c("div", { staticClass: "d-flex flex-column" }, [
            _vm.title
              ? _c(
                  "h2",
                  {
                    staticClass: "primary--text pb-0",
                    class: [_vm.titleHeading ? "text-h6" : "text-body-1"],
                  },
                  [_vm._v(" " + _vm._s(_vm.title) + " ")]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "pa-0 d-flex pr-2" },
              [
                _vm.loading
                  ? _c("v-skeleton-loader", {
                      staticClass: "my-2",
                      attrs: { type: "image", height: "28", width: "128" },
                    })
                  : _vm.noData
                  ? _c(
                      "h3",
                      {
                        class: `pt-1 grey--text text--darken-1 ${
                          _vm.noIcon ? "text-h1" : "text-h4"
                        }`,
                      },
                      [_vm._v(" 0 ")]
                    )
                  : _vm.valueString
                  ? [
                      _c(
                        "h3",
                        {
                          class: `text-truncate pt-1 text-center ${
                            _vm.noIcon ? "text-h2" : "text-h4"
                          }`,
                        },
                        [_vm._v(" " + _vm._s(_vm.valueString) + " ")]
                      ),
                    ]
                  : [
                      _vm.isPercent && !isNaN(_vm.newValue)
                        ? _c(
                            "h3",
                            {
                              class: `pt-1 ${
                                _vm.noIcon ? "text-h1" : "text-h4"
                              }`,
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatNumberFixed(_vm.newValue))
                              ),
                              _c("span", [_vm._v("%")]),
                            ]
                          )
                        : _c(
                            "h3",
                            {
                              class: `pt-1 ${
                                _vm.noIcon ? "text-h1" : "text-h4"
                              }`,
                            },
                            [_vm._v(" " + _vm._s(_vm.newValue) + " ")]
                          ),
                    ],
              ],
              2
            ),
          ]),
        ],
        1
      ),
      !_vm.noData || _vm.loading
        ? _c("div", { staticClass: "moin-bg-grey-lightest py-3 px-4" }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "d-flex gap-4" },
                  [
                    _c("v-skeleton-loader", {
                      attrs: { type: "image", height: "24", width: "72" },
                    }),
                    _c("v-skeleton-loader", {
                      attrs: { type: "image", height: "24", width: "72" },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "d-flex gap-4 items-center",
                    staticStyle: { "margin-left": "3px" },
                  },
                  [
                    _c("div", { staticClass: "d-flex items-center gap-1" }, [
                      _c(
                        "span",
                        {
                          staticClass: "grey--text text-body-2 text--darken-1",
                        },
                        [_vm._v(" " + _vm._s(_vm.minValueText) + " ")]
                      ),
                      _c("div", { staticClass: "text-body-2 primary--text" }, [
                        !_vm.noData && !_vm.hideCompare
                          ? _c("div", [
                              _vm.minValue === null ||
                              _vm.minValue === undefined
                                ? _c("span", [_vm._v("~")])
                                : _vm._e(),
                              _vm.isPercent && !isNaN(_vm.minValue)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumberFixed(_vm.minValue)
                                      ) + "%"
                                    ),
                                  ])
                                : _c("div", { staticClass: "text-truncate" }, [
                                    _vm._v(_vm._s(_vm.minValue)),
                                  ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "d-flex items-center gap-1" }, [
                      _c(
                        "span",
                        {
                          staticClass: "grey--text text-body-2 text--darken-1",
                        },
                        [_vm._v(" " + _vm._s(_vm.maxValueText) + " ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pa-0 d-flex justify-center items-end primary--text",
                        },
                        [
                          !_vm.noData && !_vm.hideCompare
                            ? [
                                _vm.maxValue === null ||
                                _vm.maxValue === undefined
                                  ? _c("span", [_vm._v("~")])
                                  : _vm._e(),
                                _vm.isPercent && !isNaN(_vm.maxValue)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNumberFixed(_vm.maxValue)
                                        ) + "%"
                                      ),
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [_vm._v(_vm._s(_vm.maxValue))]
                                    ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }